import React, { useEffect, useMemo, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import config from "../../Config";
import axios from "axios";
import Spinner from 'react-bootstrap/Spinner';
import { toast, ToastContainer } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import { Form } from "react-bootstrap";
import InvoiceMenu from "./InvoiceMenu";

function AddInvoice() {
    const [AccessKey] = useState(localStorage.getItem("AccessKey"));
    const [UserID] = useState(localStorage.getItem("ID"));
    const [MemberType] = useState(localStorage.getItem("MemberType"));
    const [DefaultFYear] = useState(localStorage.getItem("DefaultFYear"));
    const [validated, setValidated] = useState(false);
    const [loading, setLoading] = useState(false);
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();

    const invoiceId = useMemo(() => {
        const raw = searchParams.get("id");
        const parsed = raw ? parseInt(raw, 10) : 0;
        return Number.isNaN(parsed) ? 0 : parsed;
    }, [searchParams]);

    const today = new Date();
    const [formState, setFormState] = useState({
        invoiceMonth: today.getMonth() + 1,
        invoiceYear: DefaultFYear ? parseInt(DefaultFYear, 10) : today.getFullYear(),
        invoiceAmount: 0,
        invoiceStatus: "Generated",
        paymentStatus: "Pending",
        generatedDate: today.toISOString().slice(0, 10),
        paymentDate: "",
        paymentConfirmationDate: "",
        adminRemarks: "",
        isActive: true
    });

    useEffect(() => {
        if (!invoiceId) {
            return;
        }
        setLoading(true);
        const data = {
            AccessKey,
            UserID,
            MemberType,
            ID: invoiceId
        };
        axios({
            method: 'post',
            url: config.base_url + 'PaymentInvoice/GetInvoiceByID',
            headers: {
                'Content-Type': 'application/json'
            },
            data
        }).then((response) => {
            if (response.data.status_code === 1) {
                const invoice = response.data.InvoiceData;
                setFormState({
                    invoiceMonth: invoice.InvoiceMonth || today.getMonth() + 1,
                    invoiceYear: invoice.InvoiceYear || today.getFullYear(),
                    invoiceAmount: invoice.InvoiceAmount || 0,
                    invoiceStatus: invoice.InvoiceStatus || "Generated",
                    paymentStatus: invoice.PaymentStatus || "Pending",
                    generatedDate: invoice.GeneratedDate ? invoice.GeneratedDate.slice(0, 10) : today.toISOString().slice(0, 10),
                    paymentDate: invoice.PaymentDate ? invoice.PaymentDate.slice(0, 10) : "",
                    paymentConfirmationDate: invoice.PaymentConfirmationDate ? invoice.PaymentConfirmationDate.slice(0, 10) : "",
                    adminRemarks: invoice.AdminRemarks || "",
                    isActive: invoice.Is_Active === true
                });
            } else {
                toast.error(response.data.status_message, {
                    position: toast.POSITION.TOP_RIGHT
                });
            }
        }).catch(() => {
            toast.error('Network Error..', {
                position: toast.POSITION.TOP_RIGHT
            });
        }).finally(() => {
            setLoading(false);
        });
    }, [invoiceId, AccessKey, UserID, MemberType]);

    const handleChange = (field, value) => {
        setFormState((prev) => ({
            ...prev,
            [field]: value
        }));
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        event.stopPropagation();
        const form = event.currentTarget;
        if (form.checkValidity() === false) {
            setValidated(true);
            return;
        }

        setLoading(true);
        const data = {
            AccessKey,
            UserID,
            MemberType,
            ID: invoiceId,
            InvoiceMonth: parseInt(formState.invoiceMonth, 10),
            InvoiceYear: parseInt(formState.invoiceYear, 10),
            InvoiceAmount: parseInt(formState.invoiceAmount, 10) || 0,
            InvoiceStatus: formState.invoiceStatus,
            PaymentStatus: formState.paymentStatus,
            GeneratedDate: formState.generatedDate || null,
            PaymentDate: formState.paymentDate || null,
            PaymentConfirmationDate: formState.paymentConfirmationDate || null,
            AdminRemarks: formState.adminRemarks,
            InvoiceIsActive: formState.isActive,
            InvoiceIsDeleted: false
        };

        axios({
            method: 'post',
            url: config.base_url + 'PaymentInvoice/SaveInvoice',
            headers: {
                'Content-Type': 'application/json'
            },
            data
        }).then((response) => {
            if (response.data.status_code === 1) {
                toast.success(response.data.status_message, {
                    position: toast.POSITION.TOP_RIGHT
                });
                navigate('/invoice/manage-invoice');
            } else {
                toast.error(response.data.status_message, {
                    position: toast.POSITION.TOP_RIGHT
                });
            }
        }).catch(() => {
            toast.error('Network Error..', {
                position: toast.POSITION.TOP_RIGHT
            });
        }).finally(() => {
            setLoading(false);
        });

        setValidated(true);
    };

    return (
        <>
            <InvoiceMenu />
            <ToastContainer />
            <div className="page-head">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-md-6">
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item"><Link to="/Dashboard">Dashboard</Link></li>
                                    <li className="breadcrumb-item"> <Link to="/invoice/manage-invoice">Invoice</Link></li>
                                    <li className="breadcrumb-item active" aria-current="page">{invoiceId ? "Edit Invoice" : "Generate Invoice"}</li>
                                </ol>
                            </nav>
                            <div className="page-title">{invoiceId ? "Edit Invoice" : "Generate Invoice"}</div>
                        </div>
                        <div className="col-md-6">
                            <div className="page-right-actions">
                                <Link to="/invoice/manage-invoice" className="button button-white button-icon">
                                    Manage Invoice
                                    <i className="ri-list-check"></i>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="page-content">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-md-12">
                            <div className="card">
                                <div className="card-body p-md-4">
                                    <Form noValidate validated={validated} onSubmit={handleSubmit}>
                                        <div className="row align-items-center">
                                            <div className="col-md-3">
                                                <div className="form-group mb-3">
                                                    <label htmlFor="invoiceMonth">Invoice Month:</label>
                                                    <select
                                                        id="invoiceMonth"
                                                        className="form-select"
                                                        required
                                                        value={formState.invoiceMonth}
                                                        onChange={(e) => handleChange("invoiceMonth", e.target.value)}
                                                    >
                                                        <option value="0">Please Select</option>
                                                        <option value="1">January</option>
                                                        <option value="2">February</option>
                                                        <option value="3">March</option>
                                                        <option value="4">April</option>
                                                        <option value="5">May</option>
                                                        <option value="6">June</option>
                                                        <option value="7">July</option>
                                                        <option value="8">August</option>
                                                        <option value="9">September</option>
                                                        <option value="10">October</option>
                                                        <option value="11">November</option>
                                                        <option value="12">December</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="form-group mb-3">
                                                    <label htmlFor="invoiceYear">Invoice Year:</label>
                                                    <input
                                                        id="invoiceYear"
                                                        type="number"
                                                        className="form-control"
                                                        required
                                                        value={formState.invoiceYear}
                                                        onChange={(e) => handleChange("invoiceYear", e.target.value)}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="form-group mb-3">
                                                    <label htmlFor="invoiceAmount">Invoice Amount:</label>
                                                    <input
                                                        id="invoiceAmount"
                                                        type="number"
                                                        className="form-control"
                                                        required
                                                        value={formState.invoiceAmount}
                                                        onChange={(e) => handleChange("invoiceAmount", e.target.value)}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="form-group mb-3">
                                                    <label htmlFor="invoiceStatus">Invoice Status:</label>
                                                    <select
                                                        id="invoiceStatus"
                                                        className="form-select"
                                                        value={formState.invoiceStatus}
                                                        onChange={(e) => handleChange("invoiceStatus", e.target.value)}
                                                    >
                                                        <option value="Generated">Generated</option>
                                                        <option value="Paid">Paid</option>
                                                        <option value="Cancelled">Cancelled</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="form-group mb-3">
                                                    <label htmlFor="paymentStatus">Payment Status:</label>
                                                    <select
                                                        id="paymentStatus"
                                                        className="form-select"
                                                        value={formState.paymentStatus}
                                                        onChange={(e) => handleChange("paymentStatus", e.target.value)}
                                                    >
                                                        <option value="Pending">Pending</option>
                                                        <option value="Paid">Paid</option>
                                                        <option value="Partial">Partial</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="form-group mb-3">
                                                    <label htmlFor="generatedDate">Generated Date:</label>
                                                    <input
                                                        id="generatedDate"
                                                        type="date"
                                                        className="form-control"
                                                        value={formState.generatedDate}
                                                        onChange={(e) => handleChange("generatedDate", e.target.value)}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="form-group mb-3">
                                                    <label htmlFor="paymentDate">Payment Date:</label>
                                                    <input
                                                        id="paymentDate"
                                                        type="date"
                                                        className="form-control"
                                                        value={formState.paymentDate}
                                                        onChange={(e) => handleChange("paymentDate", e.target.value)}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="form-group mb-3">
                                                    <label htmlFor="paymentConfirmationDate">Payment Confirmation Date:</label>
                                                    <input
                                                        id="paymentConfirmationDate"
                                                        type="date"
                                                        className="form-control"
                                                        value={formState.paymentConfirmationDate}
                                                        onChange={(e) => handleChange("paymentConfirmationDate", e.target.value)}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-9">
                                                <div className="form-group mb-3">
                                                    <label htmlFor="adminRemarks">Admin Remarks:</label>
                                                    <textarea
                                                        id="adminRemarks"
                                                        className="form-control"
                                                        value={formState.adminRemarks}
                                                        onChange={(e) => handleChange("adminRemarks", e.target.value)}
                                                        rows="2"
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="form-group mb-3 mt-4">
                                                    <div className="form-check">
                                                        <input
                                                            id="isActive"
                                                            className="form-check-input"
                                                            type="checkbox"
                                                            checked={formState.isActive}
                                                            onChange={(e) => handleChange("isActive", e.target.checked)}
                                                        />
                                                        <label className="form-check-label" htmlFor="isActive">
                                                            Active
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-2 mt-md-2 text-end">
                                                <div className="form-group ">
                                                    {
                                                        loading ?
                                                            <Spinner animation="border" role="status"></Spinner>
                                                            :
                                                            <button type="submit" value="Save" className="button button-primary w-100 ">SAVE</button>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </Form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default AddInvoice;
